import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { message } from "antd";
import authService from "../../services/auth.service";
import { NavLink, useNavigate } from "react-router-dom";
import { BiError } from "react-icons/bi";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { loginUser } from "../../state/slices/userSlice";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({

  });

  const togglePassword = () => {
    setShowPassword((currValue) => !currValue);
  };

  const onsubmit = (data) => {
    authService
      .authenticate(data)
      .then((response) => {
        if (response.status === 200) {
          message.success("Uspjesno ste se prijavili!");

          sessionStorage.setItem("token", response.data.token);
        }
      })
      .then(() => {
        authService
          .getCurrentAccount()
          .then((userResponse) => {
            console.log("Current account -- ", userResponse.data);
            dispatch(loginUser(userResponse.data));

            navigate("/reservations");
          })
          .catch((userError) => {
            message.error("Greska prilikom preuzimanja korisnickih podataka!");
          });
      })
      .catch((err) => {
        message.error("Pogresno korisnicko ime ili lozinka!");
      });
  };

  return (
    <div className="flex items-center justify-center h-screen bg-cover bg-center">
      <div className="w-full max-w-md p-6 bg-datepickerGray rounded-lg shadow-lg">
        <form onSubmit={handleSubmit(onsubmit)}>
          <h4 className="text-footerBlue text-2xl font-bold text-center mb-6">
            Prijava
          </h4>

          <div className="mb-4">
            <label
              className="block text-footerBlue font-semibold mb-2"
              htmlFor="username"
            >
              Email
            </label>
            <input
              type="text"
              className="w-full font-semibold px-4 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              name="username"
              {...register("username", { required: true })}
            />
            {errors.username && (
              <span className="text-red-500 text-sm flex items-center mt-2">
                <BiError size={20} className="mr-2" /> Ovo polje je obavezno!
              </span>
            )}
          </div>

          <div className="mb-4">
            <label
              className="block text-footerBlue font-semibold mb-2"
              htmlFor="password"
            >
              Lozinka
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                className="w-full font-semibold px-4 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                name="password"
                {...register("password", { required: true })}
              />
              <span
                className="absolute inset-y-0 right-4 flex items-center cursor-pointer text-gray-500"
                onClick={togglePassword}
              >
                {showPassword ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
              </span>
            </div>
            {errors.password && (
              <span className="text-red-500 text-sm flex items-center mt-2">
                <BiError size={20} className="mr-2" /> Ovo polje je obavezno!
              </span>
            )}
          </div>

          <div className="flex items-center">
            <button
              type="submit"
              className="w-full bg-buttonYellow text-footerBlue font-bold py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              PRIJAVI SE
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
